<mat-nav-list class="menu-list">
  <cl-menu-list-item
    (listItemClicked)="handleListItemClicked($event)"
    (upgradeIconClicked)="handleUpgradeIconClicked($event)"
    *ngFor="let item of items; let i = index"
    [item]="item"
  ></cl-menu-list-item>
</mat-nav-list>
